import { RelatedReturns, type IRelatedReturnsProps } from "@dehub/shared-components";
import useSWR from "swr";

type ReturnsPayload = {
  returns?: unknown[];
  pagination?: { total?: number };
};

/**
 * Hides RelatedReturns entirely when /ord/returns fails or returns no rows.
 * Shared widget shows a red «Алдаа гарлаа» / empty card — suppress that chrome.
 * Uses the same SWR key so RelatedReturns reuses the cached response.
 */
export function SafeRelatedReturns(props: IRelatedReturnsProps) {
  const limit = props.limit ?? 5;
  const params =
    props.target.kind === "invoice"
      ? {
          limit,
          sortBy: "requestedAt",
          sortDir: "desc",
          invoiceId: props.target.invoiceId,
        }
      : props.target.kind === "order"
        ? {
            limit,
            sortBy: "requestedAt",
            sortDir: "desc",
            orderId: props.target.orderId,
          }
        : null;

  const { data, error, isLoading } = useSWR(
    params ? ["related-returns", JSON.stringify(params)] : null,
    () => props.httpClient.get("/ord/returns", params!),
    { revalidateOnFocus: false },
  );

  if (error) return null;
  if (isLoading && !data) return null;

  const payload = data as ReturnsPayload | undefined;
  const rows = payload?.returns;
  if (!Array.isArray(rows) || rows.length === 0) return null;

  return <RelatedReturns {...props} />;
}
